import React, { FC, useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Image,
  notification,
} from "antd";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import googleIcon from "../../assets/signInIcon/google-icon.svg";
import facebookIcon from "../../assets/signInIcon/facebook-icon.svg";
import metamaskIcon from "../../assets/signInIcon/metamask-icon.svg";
import userSelectors from "../../store/user/selectors";
import CheckMailForm from "./CheckMailForm";
import { userActions } from "../../store/user";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import FacebookLogin from "@greatsumini/react-facebook-login";

// Extend the Window interface to include ethereum
declare global {
  interface Window {
    ethereum?: any;
  }
}

interface singUpInterface {
  email: `${string | number}@${string}.${string}`;
  password: string;
  confirm_password: string;
  is_notified_email: boolean;
  ref?: string;
}
const SignUpForm: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const signUpModalVisible = useAppSelector(userSelectors.signUpModal);
  const loader = useAppSelector(userSelectors.getLoader);
  const [buttonClicked, setButtonClicked] = useState("");
  const authUser = useAppSelector(userSelectors.getUserDetails);
  const isAuthenticated = useAppSelector(userSelectors.getIsAutheticated);

  const navigateToPath = (path: string) => {
    dispatch(userActions.signUpModal({ visible: false }));
    navigate(path);
  };

  const [email, setemail] = useState("");
  const [signUpForm] = Form.useForm();
  const referralCode = localStorage.getItem("referral_code");
  const onFinish = (values: singUpInterface) => {
    setButtonClicked("emailBtn");
    if (values.email.includes("+")) {
      notification.error({
        message: "Invalid Email",
        description:
          "Email addresses with '+' are not allowed. Please enter a valid email.",
        placement: "topRight",
      });
      return;
    }

    setemail(values.email);
    if (values.password === values.confirm_password) {
      dispatch(
        userActions.signUp({
          email: values.email,
          password: values.password,
          is_notified_email: values.is_notified_email,
          ref: referralCode ? referralCode : "",
        })
      );
    } else {
      notification.error({
        message: "Password and confirm password must be same !!",
      });
    }
    signUpForm.resetFields();
  };

  const responseGoogle = async (authResult: any) => {
    try {
      if (authResult["code"]) {
        dispatch(
          userActions.googleSignUp({
            code: authResult.code,
            referralCode: referralCode ? referralCode : "",
          })
        );
      } else {
        throw new Error(authResult);
      }
    } catch (e) {
      throw new Error("Error while Signup with Google...");
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: responseGoogle,
    flow: "auth-code",
  });

  const FacebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
  const registerWithFacebook = async (authResult: any) => {
    try {
      if (authResult["accessToken"]) {
        dispatch(
          userActions.facebookSignUp({
            access_token: authResult.accessToken,
            referralCode: referralCode ? referralCode : "",
          })
        );
      } else {
        throw new Error(authResult);
      }
    } catch (e) {
      console.log("Error while Facebook Login...", e);
    }
  };

  const metamaskLogin = async () => {
    if (!window.ethereum) return alert("Please install MetaMask");

    // Connect to MetaMask
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const address = accounts[0];

    dispatch(userActions.fetchMetamaskNonce({ address: address }));
  };

  useEffect(() => {
    if (authUser && isAuthenticated) {
      navigate("/");
      dispatch(userActions.signInModal({ visible: false }));
    }
  }, [dispatch, navigate, authUser, isAuthenticated]);

  return (
    <>
      <CheckMailForm email={email} />
      {/* <SignUpForm /> */}
      <Modal
        transitionName=""
        title="Signup"
        visible={signUpModalVisible}
        centered={true}
        onCancel={() => {
          dispatch(userActions.signUpModal({ visible: false }));
          signUpForm.resetFields();
        }}
        footer={null}
      >
        <Form form={signUpForm} layout={"vertical"} onFinish={onFinish}>
          <Row gutter={[0, 15]}>
            <Col span={24}>
              <Space direction="vertical">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Email field is required!" },
                    { type: "email", message: "Invaid email id!" },
                  ]}
                >
                  <Input
                    type="email"
                    className="email-input"
                    placeholder="Email address"
                  ></Input>
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Password field is required!",
                    },
                    {
                      min: 8,
                      message: "Password must be minimum 8 characters!",
                    },
                  ]}
                >
                  <Input.Password
                    iconRender={(visible) =>
                      visible ? (
                        <EyeInvisibleOutlined style={{ color: "#707070" }} />
                      ) : (
                        <EyeOutlined style={{ color: "#707070" }} />
                      )
                    }
                    type="password"
                    className="email-input"
                    placeholder="Password"
                  ></Input.Password>
                </Form.Item>
                <Form.Item
                  name="confirm_password"
                  rules={[
                    {
                      required: true,
                      message: "Confirm Password field is required!",
                    },
                    {
                      min: 8,
                      message: "Confirm Password must be minimum 8 characters!",
                    },
                  ]}
                >
                  <Input.Password
                    iconRender={(visible) =>
                      visible ? (
                        <EyeInvisibleOutlined style={{ color: "#707070" }} />
                      ) : (
                        <EyeOutlined style={{ color: "#707070" }} />
                      )
                    }
                    type="password"
                    className="email-input"
                    placeholder="Confirm Password"
                  ></Input.Password>
                </Form.Item>

                <Form.Item name="is_notified_email">
                  <Checkbox
                    className="checkbox-btn"
                    defaultChecked
                    onChange={(value) =>
                      signUpForm.setFieldsValue({
                        is_notified_email: value.target.checked,
                      })
                    }
                  >
                    {" "}
                    I agree to receiving updates about HaveTo via email
                  </Checkbox>
                </Form.Item>
              </Space>
            </Col>
            <Col span={24}>
              <Form.Item>
                <Button
                  className="submit-button"
                  loading={
                    buttonClicked === "emailBtn" && loader ? true : false
                  }
                  disabled={loader}
                  htmlType={"submit"}
                >
                  Continue with email
                </Button>
              </Form.Item>
            </Col>
            <Col span={24}>
              <p className="continue-text">
                Already have an account?{" "}
                <span
                  className="primary-color"
                  onClick={() => {
                    dispatch(userActions.signUpModal({ visible: false }));
                    dispatch(userActions.signInModal({ visible: true }));
                  }}
                >
                  Login
                </span>
              </p>
            </Col>
            <Col span={24}>
              <hr className="or-text" />
            </Col>
            <Col span={24}>
              <div className="social-button-container">
                <Button
                  className="submit-button"
                  loading={
                    buttonClicked === "googleBtn" && loader ? true : false
                  }
                  disabled={loader}
                  onClick={() => {
                    setButtonClicked("googleBtn");
                    googleLogin();
                  }}
                >
                  <Image
                    src={googleIcon}
                    preview={false}
                    className="social-submit-button"
                  />
                  Continue with Google
                </Button>
                <FacebookLogin
                  className="facebook-submit-button"
                  appId={`${FacebookAppId}`}
                  onSuccess={async (response) => {
                    setButtonClicked("facebookBtn");
                    await registerWithFacebook(response);
                  }}
                  onFail={() => {
                    throw new Error("Facebook signup Failed!");
                  }}
                >
                  <Button
                    className="submit-button"
                    loading={
                      buttonClicked === "facebookBtn" && loader ? true : false
                    }
                    disabled={loader}
                  >
                    <Image
                      src={facebookIcon}
                      preview={false}
                      className="social-submit-button"
                    />
                    Continue with Facebook
                  </Button>
                </FacebookLogin>
                <Button
                  className="submit-button"
                  loading={
                    buttonClicked === "metamaskBtn" && loader ? true : false
                  }
                  disabled={loader}
                  onClick={() => {
                    setButtonClicked("metamaskBtn");
                    metamaskLogin();
                  }}
                >
                  <Image
                    src={metamaskIcon}
                    preview={false}
                    style={{ cursor: "pointer" }}
                    className="social-submit-button"
                  />
                  Continue with Metamask
                </Button>
              </div>
            </Col>
            <Col span={24}>
              <p className="continue-text">
                By continuing you agree to haveto.com's <br />
                <span className="imp-link">User Agreement</span>,{" "}
                <span className="imp-link">Wallet Services Terms</span> and{" "}
                <span
                  className="imp-link"
                  onClick={() => {
                    navigateToPath("/privacy-policy");
                  }}
                >
                  Privacy policy
                </span>
              </p>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default SignUpForm;
